import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Observable } from 'rxjs'

import { Preferences, UserContext } from '../models/auth'

import { environment } from '../../../environments/environment'

const meUrl = '/me'
const preferencesUrl = '/me/preferences'

@Injectable()
export class UserService {
    constructor(
        private http: HttpClient
    ) {}

    userContext(): Observable<UserContext> {
        return this.http.get<UserContext>(
            environment.baseApiUrl + meUrl
        )
    }

    savePreferences(pref: Preferences): Observable<Preferences> {
        return this.http.put<Preferences>(
            environment.baseApiUrl + preferencesUrl,
            pref
        )
    }
}
